// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"9cad5bb3","387":"b58face3","531":"e0af15d0","629":"ca71ba63","784":"9f19a6f3"}[chunkId] + ".chunk.js";
};